import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';
import { ContentLayout } from './utilities/layouts/ContentLayout';
import { RequiresLogin } from './utilities/commonUtilities/RequiresLogin';
import PropTypes from 'prop-types';
import AdaptiveNavBar from './utilities/NavBar/AdaptiveNavBar';
import Shadow from '../resources/images/shadow.svg';
import clsx from 'clsx';
import { FullScreenButtonPageStyle } from '../styles/FullScreenButtonPageStyle';
import CircularProgress from '@material-ui/core/CircularProgress';

const NonIconSection = ({ SubtitleText, bodyText, buttonText, onButtonClick, showButton = true, bodyTestDataAttr, stylesOverride, loadingButton = false }) => {
    const classes = FullScreenButtonPageStyle(stylesOverride)();

    return (
        <>
            <div className={classes.body}>
                {SubtitleText && <SubtitleText />}
                <Typography data-cy={bodyTestDataAttr} variant="body1" className={classes.bodyText}>
                    {bodyText}
                </Typography>
                {showButton &&
                    (loadingButton ? (
                        <Button className={clsx(classes.button, classes.loadingButton)} disabled={true}>
                            {<CircularProgress className={classes.loadingIcon} size={14.62} />}
                        </Button>
                    ) : (
                        <Button className={classes.button} disabled={false} onClick={onButtonClick}>
                            {buttonText}
                        </Button>
                    ))}
            </div>
        </>
    );
};

export function FullScreenButtonPage({
    isLoginRequired = false,
    Icon,
    ImageTag,
    SubtitleText,
    bodyText,
    buttonText,
    onButtonClick,
    showButton = true,
    showShadow = false,
    bodyTestDataAttr,
    stylesOverride,
    hideNavbar = false,
}) {
    if (!isLoginRequired) {
        return (
            <>
                { hideNavbar ? null : <AdaptiveNavBar mobilePresent isErrorPageHeader={true} /> }
                <FullScreenButtonPageContent Icon={Icon} ImageTag={ImageTag} showShadow={showShadow}>
                    <NonIconSection
                        stylesOverride={stylesOverride}
                        bodyTestDataAttr={bodyTestDataAttr}
                        SubtitleText={SubtitleText}
                        bodyText={bodyText}
                        buttonText={buttonText}
                        onButtonClick={onButtonClick}
                        showButton={showButton}
                    />
                </FullScreenButtonPageContent>
            </>
        );
    } else {
        return (
            <RequiresLogin>
                { hideNavbar ? null : <AdaptiveNavBar mobilePresent isErrorPageHeader={true} /> }
                <FullScreenButtonPageContent Icon={Icon} ImageTag={ImageTag} showShadow={showShadow}>
                    <NonIconSection
                        stylesOverride={stylesOverride}
                        bodyTestDataAttr={bodyTestDataAttr}
                        SubtitleText={SubtitleText}
                        bodyText={bodyText}
                        buttonText={buttonText}
                        onButtonClick={onButtonClick}
                        showButton={showButton}
                    />
                </FullScreenButtonPageContent>
            </RequiresLogin>
        );
    }
}

/* type checking for props */
FullScreenButtonPage.propTypes = {
    isLoginRequired: PropTypes.bool,
    bodyText: PropTypes.string.isRequired,
    buttonText: PropTypes.string,
    onButtonClick: PropTypes.func,
    bodyTestDataAttr: PropTypes.string,
    showShadow: PropTypes.bool,
    stylesOverride: PropTypes.any,
};

export function FullScreenPageNoButton(props) {
    return (
        <FullScreenButtonPageContent {...props}>
            <NonIconSection {...props} />
        </FullScreenButtonPageContent>
    );
}

FullScreenPageNoButton.propTypes = {
    bodyText: PropTypes.string.isRequired,
    SubtitleText: PropTypes.any,
    bodyTestDataAttr: PropTypes.string,
    showButton: PropTypes.bool,
    showShadow: PropTypes.bool,
    iconTextDataAttr: PropTypes.string,
    stylesOverride: PropTypes.any,
};

function FullScreenButtonPageContent({ Icon, ImageTag, showShadow = false, iconTextDataAttr, children, stylesOverride }) {
    const classes = FullScreenButtonPageStyle(stylesOverride)();

    return (
        <div className={classes.contentLayoutDiv}>
            <ContentLayout className={classes.fullscreenButtonPageHorizontalPaddingOverride}>
                <Box className={classes.root} display="flex">
                    <Box display="flex" flexDirection="column" className={clsx({ [classes.shadowedIcon]: showShadow })}>
                        {ImageTag && <ImageTag />}
                        {Icon && <Icon data-cy={iconTextDataAttr} aria-labelledby="icon" className={classes.icon} />}
                        {showShadow && <img src={Shadow} alt="shadow" className={classes.shadow} />}
                    </Box>
                    {children}
                </Box>
            </ContentLayout>
        </div>
    );
}
